import { render, staticRenderFns } from "./upload_arquivo.vue?vue&type=template&id=550f6722&"
import script from "./upload_arquivo.vue?vue&type=script&lang=js&"
export * from "./upload_arquivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('550f6722')) {
      api.createRecord('550f6722', component.options)
    } else {
      api.reload('550f6722', component.options)
    }
    module.hot.accept("./upload_arquivo.vue?vue&type=template&id=550f6722&", function () {
      api.rerender('550f6722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/arquivo/upload_arquivo.vue"
export default component.exports